import type { AxiosResponse } from "axios";

import { downloadFile, validateValues } from "../../utils";
import api from "../../../../../api";
import type { IUser } from "../../../../../types";
import { CommandFormValues } from "../../types";
import { datevExportSchema } from "./types";

export const handleDatevExport = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { skr, date, withReceipts } = validateValues(values, datevExportSchema);
  const { data } = await api.kontax.createDatevExport(user.id, {
    skr,
    date,
    withReceipts,
  });
  const { id } = data;
  if (!id) {
    throw new Error("Failed to create Datev exports");
  }
  // poll until the export is ready, we should leverage on an exponential backoff
  const initialDelayMs = 1000;
  const maxDelayMs = 10000;
  const totalTimeoutMs = 120000;

  let currentDelayMs = initialDelayMs;
  let totalWaitTimeMs = 0;

  while (totalWaitTimeMs < totalTimeoutMs) {
    const response = await api.kontax.getDatevExport(user.id, id);
    if (response.data.url) {
      // Use the shared download helper to trigger the download using the URL.
      downloadFile(response.data.url);
      return response;
    }

    // Wait with current delay
    const delay = currentDelayMs;
    await new Promise((resolve) => setTimeout(resolve, delay));
    totalWaitTimeMs += currentDelayMs;

    // Apply exponential backoff: double the delay, but cap at maxDelayMs
    currentDelayMs = Math.min(currentDelayMs * 2, maxDelayMs);
  }

  throw new Error("Timeout waiting for Datev export to complete");
};
